import 'jquery';
import './autoload/_bootstrap.js';
import Router from './util/Router';
import common from './routes/common';
import templateGlobalHomepage from './routes/templateGlobalHomepage';
import templateGlobalSearchPage from './routes/templateGlobalSearchPage';
import templateGlobalOffersPage from './routes/templateGlobalOffersPage';
import templateGlobalOfferSearch from './routes/templateGlobalOfferSearch';
import templateGlobalHostEventPage from './routes/templateGlobalHostEventPage';
import templateGlobalHostEventSearch from './routes/templateGlobalHostEventSearch';
import templateGlobalHostEventPaidSearch from './routes/templateGlobalHostEventPaidSearch';
import templateGlobalRegionalContent from './routes/templateGlobalRegionalContent';
import templateGlobalGiftCards from './routes/templateGlobalGiftCards';
import templateGlobalGiftCardsV2 from './routes/templateGlobalGiftCardsV2';
import templateGlobalCareers from './routes/templateGlobalCareers';
import templateGlobalContactUs from './routes/templateGlobalContactUs';
import templateGlobalSustainability from './routes/templateGlobalSustainability';
import templateGlobalCorporatePartner from './routes/templateGlobalCorporatePartner';
import templateGlobalCorporatePartnerTerms from './routes/templateGlobalCorporatePartnerTerms';
import templateHotelHomepage from './routes/templateHotelHomepage';
import templateHotelOffersPage from './routes/templateHotelOffersPage';
import templateHotelDiningPage from './routes/templateHotelDiningPage';
import templateHotelGallery from './routes/templateHotelGallery';
import templateHotelVenueWeddings from './routes/templateHotelWeddingMeetings';
import templateHotelVenueMeetings from './routes/templateHotelWeddingMeetings';
import templateHotelVenueWeddingsConversion from './routes/templateHotelVenueWeddingsConversion';
import templateHotelVenue from './routes/templateHotelVenue';
import templateHotelThingsToDo from './routes/templateHotelThingsToDo';
import templateHotelGiftCards from './routes/templateHotelGiftCards';
import templateHotelReviews from './routes/templateHotelReviews';
import templateHotelParkingDirections from './routes/templateHotelParkingDirections';
import singleCptCampaignsSales from './routes/singleCptCampaignsSales';
import singleCptGroupOffer from './routes/singleCptGroupOffer';
import singleCptVenue from './routes/singleCptVenue';
import singleCptRoom from './routes/singleCptRoom';
import singleCptEatDrink from './routes/singleCptEatDrink';
import singleCptOffer from './routes/singleCptOffer';
import singleCptOccasion from './routes/singleCptOccasion';
import singleCptThingsToDo from './routes/singleCptThingsToDo';

/**
 * Populate Router instance with DOM routes
 *
 * To construct a route, use a class from <body> tag. Eg: template-global-homepage >> templateGlobalHomepage
 *
 **/
const routes = new Router({
  // All pages
  common,

  // Global Home page
  templateGlobalHomepage,

  // Global accommodation Search page
  templateGlobalSearchPage,

  // Global offers page
  templateGlobalOffersPage,

  // Global offers Search page
  templateGlobalOfferSearch,

  // Global venues page
  templateGlobalHostEventPage,

  // Global venues Search page
  templateGlobalHostEventSearch,

  // Global venues Paid Search page
  templateGlobalHostEventPaidSearch,

  // Global regional content
  templateGlobalRegionalContent,

  // Global gift cards
  templateGlobalGiftCards,

  // Global gift cards v2
  templateGlobalGiftCardsV2,

  // Global Careers
  templateGlobalCareers,

  // Global Contact Us
  templateGlobalContactUs,

  // Global Sustainability
  templateGlobalSustainability,

  // Global Corporate Partner
  templateGlobalCorporatePartner,

  // Global Corporate Partner Terms
  templateGlobalCorporatePartnerTerms,

  // Global Campaigns & Sales
  singleCptCampaignsSales,

  // Global Group Offers
  singleCptGroupOffer,

  // Hotel Venue
  singleCptVenue,

  // Hotel Home page
  templateHotelHomepage,

  // Hotel Room Modal
  singleCptRoom,

  // Hotel Dining Modal
  singleCptEatDrink,

  // Global Offer
  singleCptOffer,

  // Global Occasion
  singleCptOccasion,

  // Hotel Things to do
  singleCptThingsToDo,

  // Hotel Gallery Modal
  templateHotelGallery,

  // Hotel Wedding Events
  templateHotelVenueWeddings,
  templateHotelVenueMeetings,

  // Hotel Weddings (Conversion)
  templateHotelVenueWeddingsConversion,

  // Hotel Venue
  templateHotelVenue,

  // Hotel Offers page
  templateHotelOffersPage,

  // Hotel Dining page
  templateHotelDiningPage,

  // Hotel Things to do,
  templateHotelThingsToDo,

  // Hotel Reviews page
  templateHotelReviews,

  // Hotel Gift Cards page
  templateHotelGiftCards,

  // Hotel Parking & Directions page
  templateHotelParkingDirections,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// Force CSS update
if (process.env.NODE_ENV !== 'production') {
  if (module.hot) {
    const reporter = window.__webpack_hot_middleware_reporter__;
    const success = reporter.success;
    reporter.success = function() {
      document.querySelectorAll('[id*="sage"]').forEach((link) => {
        link.href = link.href.replace(/(\?\d+)?$/, `?${Date.now()}`);
      });
      success();
    };
  }
}



// WEBPACK FOOTER //
// ./scripts/main.js